import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgLockOpenIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 9h14v11H5zM16 9V6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.5"
    />
    <circle cx={13} cy={14} r={2.25} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M10 14H9"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgLockOpenIcon);
const Memo = memo(ForwardRef);
export default Memo;
